// Library
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

// Service
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { LineItemAvailabilityService } from './../../../../services/seed/reports/line-item-availability.service';
import { SliderModelService } from './../../../../services/infrastructure/sliderModel.service';

//View Model
import { MasterConstants } from '../../../../common/constants/master-constants';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { ReportType } from '../../../../models/report-type.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { Subscription } from 'rxjs';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';
import { UserSecurityService } from '../../../../services/common/user-security.service';

@Component({
  selector: 'app-item-availability',
  templateUrl: './item-availability.component.html',
  styleUrls: ['./item-availability.component.scss']
})
export class ItemAvailabilityComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  private readonly originalDisplayedColumns: Array<ColumnDescription> =
    [{ columnfield: 'ProductId', headertxt: 'Product Id' },
      { columnfield: 'itemDescription', headertxt: 'Product Name' },
      { columnfield: 'seedAvailability', headertxt: 'Availability' },
      { columnfield: 'maturity', headertxt: 'Maturity' },
      { columnfield: 'seedSize', headertxt: 'Seed Size' },
      { columnfield: 'packageSize', headertxt: 'Package Size' },
      { columnfield: 'treatment', headertxt: 'Treatment' },
      { columnfield: 'technology', headertxt: 'Technology' },
      { columnfield: 'marketingBrand', headertxt: 'Marketing Brand' },
      { columnfield: 'productLine', headertxt: 'Product Line' }];
  public currentFilter = new UserReportFilter();

  displayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);
  searchResultDisplayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);

  accountId: number;
  productList: any = [];
  selectedProductList: any = [];
  productDataSource: any;
  selectedValue: string;
  searchValue: string = "";
  searchTypeList: string[] = ['Product Name', 'Marketing Brand', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Maturity', 'Product Line'];
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  filterValueList = new Array();
  isTextBoxEmpty = true;
  previousSelectedValue: string;
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  partialSearchValue = '';
  productFilters: any;
  ddlAccounts: any;
  accountsLoading = false;
  selectedAccountItem: any;
  selectedAccount: any;
  accountNameCityState: any;
  productListDS: MatTableDataSource<any>;
  bucketListDS: MatTableDataSource<any>;
  productAvailabilityListDS: MatTableDataSource<any>;
  curentDateTime: any;
  productAvailabilityList: any = [];
  isAccountSelected = false;
  itemList: string[];
  // public productSelection = new SelectionModel<any>(true, []);
  selectedCount = 0;
  bucketSelectedCount = 0;
  headerSubscription: any;
  public requestObject: any;
  paList: any = [];
  ignoreZeroQtyRecords = false;
  selectAll = false;
  chatAccess = true;

  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;
  @ViewChild('bucketPaginator', { read: MatPaginator }) bucketPaginator: MatPaginator;
  @ViewChild('bucketTable', { read: MatSort }) bucketSort: MatSort;

  constructor(
    private toastrService: ToastrService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private reportService: LineItemAvailabilityService,
    private sliderModelService: SliderModelService,
    public excelService: ExcelService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userSecurityService: UserSecurityService,
    private userReportFilterService: UserReportFilterService) {
  }
  // OnInit
  ngOnInit() {
    this.isAccountSelected = false;
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.selectedValue = this.searchTypeList[0];

    // load master data
    this.loadMasterData();
    this.resetProductFilter();
    this.getAccountList();

    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.currentFilter = filter;

          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.productFilters = filters.filterOption;
          this.displayedColumns = filters.displayedColumns.map(x => x.columnfield);

          if (!this.displayedColumns.includes('ProductId')) {
            this.displayedColumns.unshift('ProductId');
          }

          this.selectedAccount = this.productFilters.AccountNumber;
          this.accountChange(this.ddlAccounts.find(x => x.accountNumber === this.productFilters.AccountNumber))
          this.getProducts();
          this.enableDisableSearch();
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));
    this.subscription.push(this.userSecurityService.getChatAccess().subscribe(results => {
      this.chatAccess = results.isChatActive;
    }));
  }

  ngOnDestroy() {
    if (this.headerSubscription) {
      this.headerSubscription.unsubscribe();
    }

    this.userReportFilterSliderService.resetFilter();
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // to get account list
  getAccountList() {
    this.accountsLoading = true;
    this.reportService.getAccounts().subscribe((result: any[]) => {
      this.ddlAccounts = result;
      this.accountsLoading = false;
    }, error => LolLoggerService.error(error));
  }

  // search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // account dropdown change
  accountChange($event) {
    this.selectedAccountItem = $event;
    if ($event
      && $event.accountNumber) {
      this.isAccountSelected = true;
      this.accountNameCityState = $event.accountNameCityState;
    }
    else {
      this.isAccountSelected = false;
      this.accountNameCityState = '';
    }
  }

  // account clear
  accountClear($event) {
    this.accountChange(null);
  }

  // get products
  getProducts() {
    this.keepFilter();

    if (!this.selectedAccount) {
      this.toastrService.warning('Please select account.');
      return true;
    }

    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = this.accountId;
    if (!this.validateProductFilter(this.productFilters)) {
      this.toastrService.error('Value must greater than equal to 2 characters.');
      return true;
    }

    if (this.productFilters.ProductLineList
      && this.productFilters.ProductLineList.length > 0
      && (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
        (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
        (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
        (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
        (this.productFilters.TechnologyList != null && this.productFilters.TechnologyList !== '') ||
        (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
        (this.productFilters.MaturityMin != null) ||
        (this.productFilters.MaturityMax != null))) {
      // another search criteria selected with product line
    }
    else if (this.productFilters.ProductLineList
      && this.productFilters.ProductLineList.length > 0) {
      this.toastrService.error('Please pick another search attribute with product line only.');
      return true;
    }

    this.loaderService.setLoaderStatus(true);
    this.reportService.getProducts(this.productFilters).subscribe((result: any) => {
      if (result && result.status) {
        this.productList = result.resultData;
        this.productList.forEach(product => {
          product.ProductName = (product.brand != null ? product.brand : '') + (product.marketingBrand != null ? (' - ' + product.marketingBrand) : '');
          product.productNameFilter = (product.brand != null ? product.brand : '');
          product.IsProductSelected = false;
        });
      }
      else {
        if (result) {
          this.toastrService.info(result.message);
          this.productList = [];
        }
        else {
          this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
          this.productList = [];
        }
      }
      this.productDataSource = new MatTableDataSource(this.productList);
      this.productDataSource.paginator = this.productPaginator;
      this.productDataSource.paginator.firstPage();
      this.productDataSource.sort = this.productSort;
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.productList = [];
      this.productDataSource = new MatTableDataSource([]);
      this.productDataSource.paginator = this.productPaginator;
      this.productDataSource.paginator.firstPage();
      this.productDataSource.sort = this.productSort;
      this.toastrService.error('No Record Found. Please Change the Search Criteria and Search Again.');
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    });
  }

  // Get Product Availability report via email
  getProductsAvailabilityEmailReport1() {
    var dispCols = this.displayedColumns.filter(item => item !== "ProductId");
    dispCols = dispCols.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x).headertxt);

    this.productFilters.AccountNumber = this.selectedAccount;
    const data = {
      data: this.productFilters,
      displayedColumn: dispCols
    }

    this.loaderService.setLoaderStatus(true);
    this.reportService.getProductsAvailabilityEmailReport(data).subscribe(res => {
      // this.reportService.
      this.loaderService.setLoaderStatus(false);
      if (res['statusCode'] == 200) {
        this.toastrService.success('Your request is sent. You will get an email soon.');
      } else {
        this.toastrService.warning('Email not sent successfully, please try again.');
      }
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    });
  }

  public export() {
    var excelData = [];
    if (this.productAvailabilityList && this.productAvailabilityList.length > 0) {
      this.loaderService.setLoaderStatus(true);

      if (this.ignoreZeroQtyRecords) {
        this.paList = this.productAvailabilityList.filter(a => a.seedAvailability > 0);
      } else {
        this.paList = this.productAvailabilityList;
      }

      const headerText = this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x).headertxt);

      this.paList.forEach(x => {
        const exportData = new Map();

        headerText.forEach(y => {
          switch (y) {
            case 'Product Name': {
              exportData.set(y, x.brand + ' - ' + x.marketingBrand + ' - ' + x.itemDescription)
              break;
            }
            case 'Availability': {
              exportData.set(y, x.seedAvailability ? x.seedAvailability : 0)
              break;
            }
            case 'Maturity': {
              exportData.set(y, x.maturity)
              break;
            }
            case 'Seed Size': {
              exportData.set(y, x.seedSize)
              break;
            }
            case 'Package Size': {
              exportData.set(y, x.packageSize)
              break;
            }
            case 'Treatment': {
              exportData.set(y, x.treatment)
              break;
            }
            case 'Technology': {
              exportData.set(y, x.technology)
              break;
            }
            case 'Marketing Brand': {
              exportData.set(y, x.marketingBrand)
              break;
            }
            case 'Product Line': {
              exportData.set(y, x.productLine)
              break;
            }
            default: {
              break;
            }
          }
        });
        const obj = this.autoConvertMapToObject(exportData);
        excelData.push(
          obj
        );
      });
      this.excelService.exportAsExcelFile(excelData, 'ProductAvailabilityReport');
      this.loaderService.setLoaderStatus(false);
    }
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  // get product filters
  getProductFilters(productFilter) {
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    this.productFilters.AccountNumber = this.accountId;
    return productFilter;
  }

  // to validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.TechnologyList != null && productFilter.TechnologyList !== '' && productFilter.TechnologyList.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Validate Maturity Min & Max
    if (productFilter.MaturityMin != null && productFilter.MaturityMax != null) {
      isValid = true;
    }
    if (this.selectedValue == 'Maturity' && (productFilter.MaturityMin != null && productFilter.MaturityMax == null)
      &&
      (productFilter.MaturityMin != null && productFilter.MaturityMax == null)) {
      isValid = false;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }
    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TechnologyList == null)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.MaturityMin == null)
      && (productFilter.MaturityMax == null)
    ) {
      isValid = false;
    }
    return isValid;
  }

  // keep records from filter
  keepRecords(item) {
    if (item != null) {
      // item.IsProductSelected = !item.IsProductSelected
      const itemNumber = item.itemNumber;

      if (item.IsProductSelected) {
        var index = this.selectedProductList.findIndex(x => x.itemId == item.itemId);
        if (index == -1) {
          this.selectedProductList.push(JSON.parse(JSON.stringify(item)));
          this.addRemoveBucketRecords();
          this.selectedCount = this.selectedCount + 1;
        }
      }
      else {
        var index = this.selectedProductList.findIndex(x => x.itemId == item.itemId); // <-- Not supported in <IE9
        if (index !== -1) {
          this.selectedProductList.splice(index, 1);
          this.addRemoveBucketRecords();
          this.selectedCount = this.selectedCount - 1;
        }
        this.productList.forEach(product => {
          if (product.itemId == item.itemId) {
            product.IsProductSelected = item.IsProductSelected;
          }
        });
        this.productDataSource = new MatTableDataSource(this.productList);
        this.productDataSource.paginator = this.productPaginator;
        this.productDataSource.sort = this.productSort;
      }
    }
    else {
      this.productDataSource.data.forEach(product => {
        if (product.IsProductSelected) {
          var index = this.selectedProductList.findIndex(x => x.itemId == product.itemId);
          if (index == -1) {
            const bucketProduct = JSON.parse(JSON.stringify(product));
            bucketProduct.IsProductSelected = true;
            this.selectedProductList.push(bucketProduct);
          }
        } else {
          var index = this.selectedProductList.findIndex(x => x.itemId == product.itemId); // <-- Not supported in <IE9
          if (index !== -1) {
            this.selectedProductList.splice(index, 1);
            this.selectedCount = this.selectedCount - 1;
          }
        }
      });
      // bind all records to bucket
      this.addRemoveBucketRecords();
    }
  }

  // remove records
  removeRecords(item) {
    if (this.bucketSelectedCount > 0) {
      if (this.bucketListDS) {
        if (item != null) {
          item.IsProductSelected = !item.IsProductSelected;
          this.productList.forEach(product => {
            if (product.itemId == item.itemId) {
              product.IsProductSelected = false;
            }
          });
          this.productDataSource = new MatTableDataSource(this.productList);
          this.productDataSource.paginator = this.productPaginator;
          this.productDataSource.sort = this.productSort;

          const index = this.selectedProductList.findIndex(x => x.itemId == item.itemId);    // <-- Not supported in <IE9
          if (index !== -1) {
            this.selectedProductList.splice(index, 1);
            this.addRemoveBucketRecords();
          }
          this.selectedCount = this.selectedCount - 1;
        }
        // to remove all records from the bucket
        else {
          this.onCancel();
        }
      }
    }
  }

  // keep filter for keepih th efilter chnged drop down
  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          let strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }
        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }
        
        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          this.filterValueList.push('Maturity : (' + this.productFilters.MaturityMin + ') - (' + this.productFilters.MaturityMax + ')');
        }
      }
    }
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
      (this.productFilters.TechnologyList != null && this.productFilters.TechnologyList !== '') ||
      (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.MaturityMin != null) ||
      (this.productFilters.MaturityMax != null)) {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();

    this.accountId = this.selectedAccount;
    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // enable disable search
  enableDisableSearch() {
    if (this.validateProductFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // validate product sraech
  validateProductSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null
      && this.productFilters.Brand !== ''
      && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // validate Technology sraech
  validateTechnologySearch() {
    // To Technology Brand
    if (this.productFilters.TechnologyList !== null
      && this.productFilters.TechnologyList !== ''
      && this.productFilters.TechnologyList.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // clearr all Filters
  clearAllFilter() {
    this.selectAll = false;
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.isTextBoxEmpty = true;
    this.resetProductFilter();
    this.productDataSource = new MatTableDataSource([]);
    this.productDataSource.paginator = this.productPaginator;
    this.productDataSource.sort = this.productSort;
    this.selectedCount = 0;
    this.userReportFilterSliderService.resetFilter();
    this.currentFilter = new UserReportFilter();
    this.displayedColumns = this.originalDisplayedColumns.map(x => x.columnfield);
  }

  // clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.productList = new Array();
        this.productDataSource = new MatTableDataSource([]);
        this.productDataSource.paginator = this.productPaginator;
        this.productDataSource.sort = this.productSort;
        this.selectedCount = 0;
      }
      this.enableDisableSearch();
    }
  }

  //Select filter
  public selectFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList
    };

    filters.filterOption.AccountNumber = this.selectedAccount;

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.ProductAvailability, 0, this.originalDisplayedColumns.filter(x => x.columnfield !== 'ProductId'), newFilter);
  }

  //Add filter
  public addFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList
    };

    filters.filterOption.AccountNumber = this.selectedAccount;

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.ProductAvailability, 1, this.originalDisplayedColumns.filter(x => x.columnfield !== 'ProductId'), newFilter);
  }

  public editFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x)).filter(x => x.columnfield !== 'ProductId')
    };

    filters.filterOption.AccountNumber = this.selectedAccount;

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.originalDisplayedColumns.filter(x => x.columnfield !== 'ProductId'), this.currentFilter);
  }

  public save(): void {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x)).filter(x => x.columnfield !== 'ProductId')
    };

    filters.filterOption.AccountNumber = this.selectedAccount;

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.subscription.push(this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
    else {
      this.subscription.push(this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
  }

  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.productFilters.Brand = null;
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        break;
      case 'Technology':
        this.productFilters.TechnologyList = null;
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        break;
      default:
        break;
    }
  }

  // load master data
  loadMasterData() {
    // Product master data
    // if (this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST)) {
    //  this.productMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST));
    // }

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
  }

  // search in master search area
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.value.toLocaleLowerCase().indexOf(term) > -1;
  }

  // partial search
  partialSearch(searchValue: string) {
    if (searchValue != undefined) {
      this.partialSearchValue = searchValue;
    }
  }

  // reset product filter
  resetProductFilter() {
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'AccountNumber': this.accountId,
      'Brand': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': null,
      'TreatmentList': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
    };
  }

  // add Remove bucket records
  addRemoveBucketRecords() {
    this.bucketListDS = new MatTableDataSource(this.selectedProductList);
    this.bucketListDS.paginator = this.bucketPaginator;
    this.bucketListDS.sort = this.bucketSort;
    this.bucketSelectedCount = this.selectedProductList.length;
  }

  // get product availability
  getProductAvailability() {
    // Fixed Bug #40958  - by Ashutosh
    if (this.selectedProductList.length > 250) {
      this.toastrService.warning('A maximum of 250 items can be selected for Availability');
      return;
    }
    this.itemList = [];
    this.selectedProductList.forEach(x => {
      this.itemList.push(x.itemNumber);
    });

    const data = {
      CompanyCode: this.headerCompany,
      AccountNumber: this.selectedAccount,
      AccountName: this.accountNameCityState,
      ItemNumberList: this.itemList,
    };

    if (this.isAccountSelected && this.itemList.length > 0) {
      this.sliderModelService.setRequestData<any>(data);
      this.sliderModelService.activeSlider('ItemAvailabilityDetailSlider');
    }
  }

  public bindDataSource(data: any[]) {
    this.productAvailabilityListDS = new MatTableDataSource(data);
  }

  // get product availability
  public getProductsAvailability() {
    // Fixed Bug #40958  - by Ashutosh
    if (this.selectedProductList.length > 250) {
      this.toastrService.warning('A maximum of 250 items can be selected for Availability');
      return;
    }
    this.itemList = [];
    this.selectedProductList.forEach(x => {
      this.itemList.push(x.itemNumber);
    });

    const data = {
      CompanyCode: this.headerCompany,
      AccountNumber: this.selectedAccount,
      AccountName: this.accountNameCityState,
      ItemNumberList: this.itemList,
    };

    // if (this.isAccountSelected && this.itemList.length > 0) {
    //  this.sliderModelService.setRequestData<any>(data);
    //  this.sliderModelService.activeSlider('ItemAvailabilitySlider');
    // }

    // data = this.requestObject;
    this.loaderService.setLoaderStatus(true);
    this.reportService.getProductsAvailability(data).subscribe((results: any[]) => {
      if (results) {
        this.productAvailabilityList = results;
        if (this.productAvailabilityList && this.productAvailabilityList.length > 0) {
          // this.curentDateTime = new Date();
          // this.bindDataSource(this.productAvailabilityList);
          if (this.ignoreZeroQtyRecords) {
            this.bucketListDS = new MatTableDataSource(this.productAvailabilityList.filter(a => a.seedAvailability > 0));
          } else {
            this.bucketListDS = new MatTableDataSource(this.productAvailabilityList);
          }
          // this.bucketListDS = new MatTableDataSource(this.productAvailabilityList);
          this.bucketListDS.paginator = this.bucketPaginator;
          this.bucketListDS.paginator.firstPage();
          this.bucketListDS.sort = this.bucketSort;
        }
        this.loaderService.setLoaderStatus(false);
      }
      else {
        this.productAvailabilityList = [];
        // this.bindDataSource(this.productAvailabilityList);
        this.bucketListDS = new MatTableDataSource(this.productAvailabilityList);

        this.bucketListDS.paginator = this.bucketPaginator;
        this.bucketListDS.paginator.firstPage();
        this.bucketListDS.sort = this.bucketSort;
        this.loaderService.setLoaderStatus(false);
      }
    }, error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    });
  }

  // filter the dealer order lines on the basis of "Dislpay Non-Zero Lines only" checkbox
  public filterNonZeroAvailabilityDetail(getZeroQtyRecordsChecked: boolean) {
    // this.addRemoveBucketRecords();
    this.ignoreZeroQtyRecords = getZeroQtyRecordsChecked;

    if (this.ignoreZeroQtyRecords) {
      this.paList = this.productAvailabilityList.filter(a => a.seedAvailability > 0);
    } else {
      this.paList = this.productAvailabilityList;
    }
    // this.bindDataSource(this.paList);
    this.bucketListDS = new MatTableDataSource(this.paList);
    this.bucketListDS.paginator = this.bucketPaginator;
    this.bucketListDS.paginator.firstPage();
    this.bucketListDS.sort = this.bucketSort;
    // this.bucketListDS(this.paList);
  }

  // on cancel
  onCancel() {
    this.selectedProductList = [];
    this.addRemoveBucketRecords();

    this.productDataSource.data.forEach(row => {
      row.IsProductSelected = false;
    });
    this.selectedCount = 0;
    this.selectAll = false;
  }

  // is all product selected
  isAllProductSelected() {
    if (this.productDataSource) {
      const startIndex = ((this.productPaginator.pageIndex) * this.productPaginator.pageSize);
      const lastIndex = ((this.productPaginator.pageIndex + 1) * this.productPaginator.pageSize);

      let filterData = this.productDataSource.data.filter((x, index) => index >= startIndex && index < lastIndex && x.IsProductSelected);
      let selectedPageRowsLength = this.productDataSource.data.length - startIndex;
      let isAllRowsSelected = filterData.length == (selectedPageRowsLength < this.productPaginator.pageSize ? selectedPageRowsLength : this.productPaginator.pageSize);
      if (isAllRowsSelected) {
        this.selectAll = true;
      } else if (filterData.length == 0) {
        this.selectAll = false;
      }
      return isAllRowsSelected;
    }
    else {
      return false;
    }
  }

  // To validate intermediate on checkbox control
  isProductSelected() {
    if (this.productDataSource) {
      const startIndex = ((this.productPaginator.pageIndex) * this.productPaginator.pageSize);
      const lastIndex = ((this.productPaginator.pageIndex + 1) * this.productPaginator.pageSize);

      const numSelected = this.productDataSource.data.filter((x, index) => index >= startIndex && index < lastIndex && x.IsProductSelected == true);
      return numSelected.length > 0;
    }
    else {
      return false;
    }
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // set account table height
  setAccountTableHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.reportPageContainerOuter').css('height', tableHeight + 'px');
  }

  onPaginateChange() {
    this.onCancel();
  }

  // product toggle
  productToggle() {
    if (this.productDataSource) {
      let itemIndex = 0;
      const lastIndex = ((this.productPaginator.pageIndex + 1) * this.productPaginator.pageSize);
      const startIndex = ((this.productPaginator.pageIndex) * this.productPaginator.pageSize);

      this.productDataSource.data.forEach(row => {
        if (itemIndex >= startIndex && itemIndex < lastIndex) {
          row.IsProductSelected = this.selectAll;
          const index = this.selectedProductList.findIndex(x => x.itemId == row.itemId); // <-- Not supported in <IE9
          if (index == -1) {
            this.selectedCount = this.selectedCount + 1;
          }
        } else {
          row.IsProductSelected = false;
        }
        itemIndex = itemIndex + 1;
      });
      this.keepRecords(null);
    }
  }

  // productCheckEvent
  productCheckEvent(row: any, isChecked: boolean) {
    // this.productSelection.toggle(row);
    if (isChecked == true) {
      row.IsProductSelected = true;
      this.keepRecords(row);
    }
    else {
      row.IsProductSelected = false;
      this.keepRecords(row);
    }
  }
}
